<template>
  <div style="padding: 20px 20px 20px 0">
    <!-- tab页 -->
    <!-- <el-tabs v-model="selectForm.flag" @tab-click="$refs.selectForm.resetFields(); getAll()">
			<el-tab-pane label="公寓" name="1">

			</el-tab-pane>
			<el-tab-pane label="商场" name="2">

			</el-tab-pane>
		</el-tabs> -->
    <div>
      <el-form :inline="true" :model="selectForm" ref="selectForm">
        <el-form-item label="业主单位" prop="company">
          <el-autocomplete
            style="width: 150px"
            v-model="selectForm.company"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择所属单位"
            value-key="unitName"
            clearable
            @clear="clearSearch"
            ref="myAutocompleteCompany"
          >
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="栋" prop="building">
          <el-input v-model="selectForm.building" placeholder="请输入栋"></el-input>
        </el-form-item>
        <el-form-item label="房间号" prop="roomNum">
          <el-input v-model="selectForm.roomNum" placeholder="请输入房间号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="日期" prop="queryDate">
					<el-date-picker style="width: 100%" clearable v-model="queryDate" type="daterange" align="right"
						unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						:picker-options="pickerOptions" value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item> -->
        <!--el-form-item label="开票状态" prop="invoiceStatus">
					<el-input v-model="selectForm.invoiceStatus" placeholder="请选择开票状态"></el-input>
				</el-form-item-->
        <!-- <el-form-item prop="invoiceStatus" label="开票状态">
					<el-select v-model="selectForm.invoiceStatus" placeholder="请选择开票状态">
						<el-option label="已开票" :value="1"></el-option>
						<el-option label="未开票" :value="0"></el-option>
					</el-select>
				</el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="getAll">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="
              $refs.selectForm.resetFields();
              query();
            "
            >重置</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addTemplate">下载导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload
            :before-upload="beforeUpload"
            action="/api/admin/report/water/room/public/upload"
            name="multipartFile"
            :show-file-list="false"
            :headers="headers"
            :on-success="success"
          >
            <el-button type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="exportsData">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="data" style="width: 100%" v-loading="loading">
      <el-table-column prop="ownerName" label="业主单位" align="center"></el-table-column>
      <el-table-column prop="building" label="栋" align="center"></el-table-column>
      <el-table-column prop="roomName" label="房间号" align="center"></el-table-column>
      <el-table-column prop="prePaid" label="预充值金额" align="center"></el-table-column>
      <el-table-column
        prop="totalVolume"
        label="公摊用水量"
        align="center"
      ></el-table-column>
      <el-table-column prop="price" label="单价" align="center"></el-table-column>
      <el-table-column
        prop="deductMoney"
        label="扣费金额"
        align="center"
      ></el-table-column>
      <el-table-column prop="remaining" label="余额" align="center"></el-table-column>
      <el-table-column prop="invoiceStatus" label="开票状态" align="center">
        <template slot-scope="{ row }">
          {{ row.invoiceStatus == 1 ? "已开票" : row.invoiceStatus == 0 ? "未开票" : "" }}
        </template>
      </el-table-column>
    </el-table>
    <!-- 搜索条件 -->

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :page-sizes="[10, 20, 30, 40]"
      :current-page.sync="selectForm.pageNum"
      :page-size="selectForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
import publicExport from "../../../assets/js/publicExport.js";
export default {
  data() {
    return {
      upLoadLoading: {},
      headers: {
        //请求头
        Authorization: localStorage.access_token,
      },
      // 遮罩层
      loading: true,
      count: null,
      sum: null,
      headerData: {
        Authorization: localStorage.access_token,
      },
      queryDate: [],
      data: [], //表格数据
      selectForm: {
        //查询条件
        type: 0,
        roomNum: "",
        accountNumber: null,
        property: null,
        status: null,
        unitPay: "",
        pageNum: 1, //当前页
        pageSize: 10, //页大小
        flag: "1",
      },
      invoiceStatusOptions: [],
      totalNum: 0, //数据总数
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    exportsData() {
      publicExport(
        "/api/report/shop/electricity/room/exportList",
        {
          ...this.selectForm,
        },
        "公寓公摊水费报表"
      );
    },
    addTemplate() {
      //下载导入模板
      this.$http
        .post(`/api/report/template/download`, this.selectForm, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=utf-8",
          },
          responseType: "blob",
        })
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "公摊水费导入模板.xls";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    beforeUpload(file, fileList) {
      this.upLoadLoading = this.$loading({
        lock: true,
        text: "导入中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    success(res) {
      this.upLoadLoading.close();
      if (res.code == 0) {
        this.getAll();
        this.$message.success("导入成功");
      } else {
        this.$message.error("导入失败");
      }
    },
    query() {
      this.selectForm.pageNum = 1;
      this.getAll();
    },
    invoiceStatusFormat(row, column) {
      if (row) {
        return this.selectDictLabel(this.invoiceStatusOptions, row.invoiceStatus);
      }
    },
    querySearchAsync(queryString, cb) {
      this.$http
        .get("/api/ownerManage/getOwners?company=" + this.selectForm.unitPay)
        .then((res) => {
          console.log("查询所有单位信息", res);
          let result = res.data.data;
          cb(result);
        });
    },
    // 解决el-autocomplete使用clearable，失效问题
    clearSearch() {
      this.$refs.myAutocompleteCompany.handleFocus();
    },

    getAll() {
      //获取表格数据
      this.selectForm.isPublic = 1; //是否公摊 (1是 0否)
      this.selectForm.sort = 1; //缴费类别（1水费 2电费）
      this.selectForm.type = 1; //所属类型（1公寓 2商铺）
      if (this.queryDate != null && this.queryDate.length == 2) {
        this.selectForm.startDate = this.queryDate[0];
        this.selectForm.endDate = this.queryDate[1];
      } else {
        this.selectForm.startDate = null;
        this.selectForm.endDate = null;
      }

      this.$http
        .post(`/api/report/water/room/public/list`, {
          ...this.selectForm,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.data = res.data.data.items;
            this.totalNum = res.data.data.totalNum;
            this.count = res.data.data.totalNum;
            this.loading = false;
          } else {
            this.data = [];
            this.totalNum = 0;
            this.count = 0;
            this.sum = 0;
            this.loading = false;
          }
        });
    },
    sizeChange(size) {
      //页大小被修改
      this.selectForm.pageSize = size;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      this.selectForm.pageNum = page;
      this.getAll();
    },
  },
  mounted() {
    this.getAll();
    this.$http.get("/api/system/dict/data/type/invoiceStatus").then((res) => {
      this.invoiceStatusOptions = res.data.data;
      //console.log('invoiceStatusOptions:',JSON.stringify(this.invoiceStatusOptions))
    });
  },
};
</script>

<style></style>
